import { Icon } from '../Icon';

export function GoalHeader(): JSX.Element {
  return (
    <div className="w-full px-3 py-2 bg-[#fdf5f6] rounded-xl border border-[#f6d6d9] flex  justify-start items-center gap-3 overflow-hidden">
      <Icon name="target" className="w-12 h-12" />
      <div className="flex justify-start items-end gap-3 text-[#8c8c8c] font-['Nunito'] text-base">
        <div className="text-[#434343] text-lg font-bold  leading-7">
          Our Goal:
        </div>
        <div>
          <span className="  font-semibold  ">
            Every employee must maintain at least a{' '}
          </span>
          <span className="text-[#ce3f4f] text-2xl font-medium  ">90%</span>
          <span className="  font-semibold  "> check-in rate.</span>
        </div>
      </div>
    </div>
  );
}
